export const MenuIdCommunications = 'COMMUNICATIONS' as const;
